import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap-5';

import { isEmpty } from 'lodash';
import { createNote, updateNote } from '../../helpers/prospect_api';
import TrixEditor from 'shared/trix/trix_editor';
import { displayToast } from '../../helpers/display_toast';
import type { Note } from 'bundles/connect/types';

type Props = {
  insightsPropertyId?: string,
  note?: Note,
  onClose: () => void,
  onSave: (note: Note) => void
}


export default function PropertyNoteForm({ insightsPropertyId, note, onClose, onSave }: Props) {
  const [body, setBody] = useState(note?.body || '');

  const handleSave = () => {
    if (note?.id) {
      updateNote(note.id, body).then((updatedNote) => {
        onSave(updatedNote);
        displayToast('Note successfully updated', 'success');
      })
        .catch(() => displayToast('Something went wrong', 'error'));
    } else {
      createNote(body, undefined, undefined, insightsPropertyId, undefined).then(onSave);
    }
  };

  return (
    <div className="p-4 mb-3">
      <Form.Group>
        <Form.Label>{note?.id ? 'Edit Note' : 'New Note'}</Form.Label>
        <TrixEditor id="new-note" initialValue={body || ''} name="body" onChange={setBody} />
      </Form.Group>
      <div className="d-flex align-items-center justify-content-end gap-2 mt-2">
        <Button variant="link" onClick={onClose}>
          Cancel
        </Button>
        <Button disabled={isEmpty(body)} variant="secondary" onClick={handleSave}>
          Save
        </Button>
      </div>
    </div>
  );
}
